<template lang="pug">
.slm
  .slmBlock(v-if="slideData.length !== 0")
    .slmTop(v-html="video_data")
    .slmBottom(
      v-for="item in slideData.slice(p,p+1)" :key="item.title" 
      @mouseover.prevent="havemouse()" @mouseleave="nomouse()"
    ) 
      ImgLoader(
        :img="item.media.src" 
        :style="{'--bgPos': 'center', '--default-url': 'none'}"
      )
      .slmPrev(@click="p==0? p=4 :p--")
      .slmNext(@click="p==slideData.length - 1? p=0 :p++")
      //文字框
      a.slmTextBlock(:href="item.link")
        .slmTitle {{ item.title }}
        .slmSubTitle {{ item.sub_title }}
  .slmDotBlock
    .slmDot(v-for="item in dot" :key="item" :class="{active: item==p}" @click="p=item")

</template>

<script>

export default {
  props: {
    videoUrl: {
      type: String,
      default: ''
    },
    slideData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      slide: null,
      p: 0
    }
  },
  mounted() {
    var s = this.p
    this.slide = setInterval(() => this.setSlide(), 8000)
  },
  computed: {
    dot() {
      if (this.slideData.length !== 0) {
        var d = []
        for (var i = 0; i <= this.slideData.length - 1; i++) {
          d.push(i)
        }
        return d
      }
    },
    video_data() {
      return `<iframe width="100%" height="100%" src="${this.videoUrl}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
    }
  },
  methods: {
    setSlide() {
      if (this.slideData.length !== 0) {
        if (this.p == this.slideData.length - 1) {
          this.p = 0
        } else {
          this.p += 1
        }
      }
    },
    havemouse() {
      clearInterval(this.slide)
    },
    nomouse() {
      this.slide = setInterval(() => this.setSlide(), 8000)
    }
  },
  beforeDestroy() {
    clearInterval(this.slide)
  }
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.slm
  position: relative
  width: 95%
  height: 115vw
  min-height: 600px
  min-width: 300px
  box-sizing: border-box
  // +bb
  +flexcolumn
  +phone
    height: 190vw
  .slmBlock
    width: 100%
    height: 95%
    box-sizing: border-box
    position: relative
    .slmTop
      position: absolute
      width: 100%
      height: 53.5%
      top: 0
      // +bb
      background-color: black
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0 83%)
      +phone
        height: 53.9%
      +ie
        height: 49.5%
        
    .slmBottom
      position: absolute
      width: 100%
      height: 53.5%
      bottom: 0
      // +bb
      clip-path: polygon(0 0, 100% 17%, 100% 100%, 0 100%)
      animation: fade 0.5s ease
      +phone
        height: 53.9%
      +ie
        height: 49.5%
      .slmPrev
        position: absolute
        +size(40px)
        background: url('../assets/slide/prev.png')
        z-index: 9
        +bgcon
        top: 50%
        left: 2%
        margin-top: -20px
        cursor: pointer
        opacity: 0.8
        
      .slmNext
        position: absolute
        +size(40px)
        background: url('../assets/slide/next.png')
        z-index: 9
        +bgcon
        top: 50%
        right: 2%
        margin-top: -20px
        cursor: pointer
        opacity: 0.8
        
      //文字框
      .slmTextBlock
        position: absolute
        width: 100%
        height: 40%
        // opacity: 0
        background-color: rgba(black,0.7) 
        bottom: 0
        padding: 10px
        box-sizing: border-box
        transition: 0.3s
        cursor: pointer
        +phone
          // display: none
        .slmTitle
          width: 94%
          color: white
          font-weight: 700
          height: 60%
          font-size: 35px
          overflow: hidden
          text-overflow: ellipsis
          display: -webkit-box
          -webkit-line-clamp: 2
          -webkit-box-orient: vertical
          +pad
            // +bb
            font-size: 4vw
          +phone
            width: 100%
            height: 50%
            font-size: 5vw
            line-height: 9.5vw
        .slmSubTitle
          color: white
          height: 30%
          padding: 15px 0 0 0
          font-size: 25px
          overflow: hidden
          text-overflow: ellipsis
          white-space: nowrap
          +pad
            font-size: 3vw
          +phone
            font-size: 4vw
            letter-spacing: 0.2vw

            // font-size: 20px
            // display: none


  .slmDotBlock
    width: 100%
    height: 5%
    +flexrow
    align-items: center
    .slmDot
      +size(6%, 10%)
      +bb
      border-color: #878787
      margin-right: 1.5%
      border-radius: 20px
      cursor: pointer
      &.active
        background-color: #878787
</style>


// WEBPACK FOOTER //
// src/components/SliderM.vue